// extracted by mini-css-extract-plugin
export var contentBody = "_a2-9";
export var headerImage = "_a2-2";
export var imageButton = "_a2-7";
export var imageButtonIcon = "_a2-8";
export var imageHeader = "_a2-4";
export var imageHeaderText = "_a2-5";
export var imageOverlay = "_a2-3";
export var imageTitle = "_a2-6";
export var imageWrapper = "_a2-1";
export var taskList = "_a2-a";
export var widget = "_a2-0";